export const REASONS = {
  SELFIE_KTP: "selfie_ktp",
  BORROWER_PHONE_NUMBER: "borrower_phone_number",
  SPOUSE_PHONE_NUMBER: "spouse_phone_number",
  FATHER_PHONE_NUMBER: "fathers_phone_number",
  MOTHER_PHONE_NUMBER: "mothers_phone_number",
  REFERENCE_PHONE_NUMBER: "reference_phone_number",
  KTP: "ktp",
  SPOUSE_KTP: "spouse_ktp",
  FATHER_KTP: "father_ktp",
  MOTHER_KTP: "mother_ktp",
  REFERENCE_KTP: "reference_ktp",
  FAMILY_CARD: "family_card",
  RECEIPT_OF_PAYMENT: "receipt_of_payment",
  EMPLOYEMENT_CONTRACT_DOCUMENT: "employment_contract_document",
  FINANCING_RECEIPTS: "financing_receipts",
  CAPACITY_PROOF: "capacity_proof",
  COE: "coe",
  VISA: "visa",
  AIR_LINE_TICKETS: "air_line_tickets",
  PASPORT: "pasport",
  SELFIE_CONTRACT_DOKUMEN: "selfie_contract_document",
  POWER_ATTORNEY_DOCUMENT: "power_attorney_document",
  SELFIE_POWER_ATTORNEY_DOCUMENT: "selfie_power_attorney_document",
  PARENTAL_FORM: "parental_consent_form",
  RO_MEMBERSHIP_APPLICATION_DOCUMENT: "ro_membership_application_document",
  RO_POWER_ATTORNEY_DOCUMENT: "ro_power_attorney_document",
  RO_SELFIE_POWER_ATTORNEY_DOCUMENT: "ro_selfie_power_attorney_document",
  INVOICE_OPP: "invoice_opp",
  MEDICAL_CHECK_DOCUMENT: "medical_check_document",
  PERSONAL_GUARANTEE_DOCUMENT: "personal_guarantee_document",
  PARENT_PERSONAL_GUARANTEE_SELFIE: "parent_personal_guarantee_selfie",
  INDOONESIAN_WORKER_CARD: "indonesian_worker_card",
  COC: "coc",
  REFERENCE_CONSENT_FORM: "reference_consent_form",
  NPWP : "npwp",
  COLLATERAL_DOCUMENT: "collateral_document",
  COLLATERAL_POA: "collateral_poa",
  COLLATERAL_OWNER_KTP: "collateral_owner_ktp",
};
